import "./App.scss";
import { Outlet, Route, Routes } from "react-router-dom";
import ComponentShowCase from "./pages/ComponentShowCase";
import Login from "./pages/Login";
import { LayoutProvider } from "./contexts/layout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Layout from "./components/Layout";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import UserForm from "./pages/UserForm";
import NFCPage from "./pages/NFCPage";
import UserDetail from "./pages/UserDetail";
import ProtectedAuth from "./components/ProtectedAuth";
import ProtectedRoute from "./components/ProtectedRoutes";
import useAuth from "./hooks/useAuth";
import ProductForm from "./pages/ProductsForm";
import PrivacyPolicy from "./pages/PrivayPolicy";
import Notification from "./pages/Notification";
import Warehouse from "./pages/Warehouse";
import StockQuantity from "./pages/StockQuantity";
import StockQuantityAdd from "./pages/StockQuantityAdd";
import StockTransfer from "./pages/StockTransfer";
import StockTransferAdd from "./pages/StockTransferAdd";
import Cookies from "js-cookie";
import NewsPage from "./pages/News";
import SetProductNumber from "./pages/SetProductNumber";

function App() {
  const { auth } = useAuth();
  const isAuthenticated = !!Cookies.get("access_token");

  return (
    <div className='App'>
      <LayoutProvider>
        <Routes>
          <Route path='/' Component={Login} />
          <Route path='/privacy-policy' Component={PrivacyPolicy}></Route>
          <Route path='/nfc-test' Component={NFCPage} />
          <Route
            element={
              <ProtectedAuth isAuth={auth.accessToken || isAuthenticated}>
                <Layout children={<Outlet />} />
              </ProtectedAuth>
            }>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/dashboard' Component={Dashboard} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/products' Component={Products} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/products/product-detail/:id' Component={ProductDetail}/>
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/products/add-product/' Component={ProductForm} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/products/edit-product/:id' Component={ProductForm}/>
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/users' Component={Users} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/users/add-user' Component={UserForm} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/users/edit-user' Component={UserForm} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/users/user-detail/:id' Component={UserDetail} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin", "admin"]} />}>
              <Route path='/inventory/stock-quantity' Component={StockQuantity}/>
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/inventory/set-product-number' Component={SetProductNumber}/>
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin", "admin"]} />}>
              <Route path='/inventory/stock-quantity/add-stock' Component={StockQuantityAdd}/>
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin", "admin"]} />}>
              <Route path='/inventory/stock-transfer' Component={StockTransfer}/>
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin", "admin"]} />}>
              <Route path='/inventory/stock-transfer/add' Component={StockTransferAdd}/>
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/notification' Component={Notification} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/settings/warehouse' Component={Warehouse} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super_admin"]} />}>
              <Route path='/settings/news' Component={NewsPage} />
            </Route>

            <Route path='/component' Component={ComponentShowCase} />
          </Route>
        </Routes>
      </LayoutProvider>
    </div>
  );
}

export default App;
